/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Tab_UsedInputs */

const en_admin_invite_codes_tab_used = /** @type {(inputs: Admin_Invite_Codes_Tab_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used`)
};

const zh_admin_invite_codes_tab_used = /** @type {(inputs: Admin_Invite_Codes_Tab_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已使用`)
};

/**
* | output |
* | --- |
* | "Used" |
*
* @param {Admin_Invite_Codes_Tab_UsedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_tab_used = /** @type {((inputs?: Admin_Invite_Codes_Tab_UsedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Tab_UsedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_tab_used(inputs)
	return zh_admin_invite_codes_tab_used(inputs)
});
export { admin_invite_codes_tab_used as "admin.invite_codes.tab_used" }